import React from "react";

const DailyAttendancePrint = ({
    open,
    onClose,
    attendanceData = [],
    attendanceDate,
    restaurantName,
    summary,
}) => {
    if (!open) return null;

    const handlePrint = () => {
        window.print();
    };


    /* ================= STATUS ================= */
    const STATUS_CODES = {
        Present: "PRE",
        Absent: "ABS",
        Late: "LAT",
        Suspense: "SUS",
    };

    const getStatus = (row) => {
        if (row.isAbsent) return STATUS_CODES.Absent;
        if (row.isSuspense) return STATUS_CODES.Suspense;
        if (row.isLate) return STATUS_CODES.Late;
        return STATUS_CODES.Present;
    };

    /* ================= FORMAT TIME ================= */
    const formatPunchTime = (dateTime) => {
        if (!dateTime) return "-";

        try {
            const str = String(dateTime).trim();

            const match = str.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);

            if (match) {
                const hour = parseInt(match[1], 10);
                const minute = match[2];
                const ampm = match[3].toUpperCase();

                return `${hour}:${minute}${ampm}`;
            }

            return "-";
        } catch {
            return "-";
        }
    };

    /* ================= PRINT HELPERS ================= */

    const LINE_WIDTH = 42;
    const dashLine = "-".repeat(LINE_WIDTH);

    const pad = (value, length) => {
        const str = String(value ?? "");

        if (str.length >= length) {
            return str.substring(0, length);
        }

        return str + " ".repeat(length - str.length);
    };

    const COL = {
        id: 4,
        name: 16,
        in: 8,
        out: 8,
    };



    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center print:block print:bg-white">
            <div className="bg-white w-[95%] max-w-5xl rounded-lg shadow-lg print:shadow-none print:w-full">

                <div className="flex justify-between items-center p-4 border-b print:hidden">
                    <h2 className="text-lg font-semibold">
                        Daily Attendance Report
                    </h2>

                    <div className="flex gap-2">
                        <button
                            onClick={handlePrint}
                            className="bg-blue-600 text-white px-4 py-2 rounded"
                        >
                            Print
                        </button>

                        <button
                            onClick={onClose}
                            className="bg-gray-600 text-white px-4 py-2 rounded"
                        >
                            Close
                        </button>
                    </div>
                </div>

                <div className="p-5 overflow-auto max-h-[80vh] flex justify-center print:p-0 print:max-h-none">
                    <div
                        id="thermal-receipt"
                        style={{
                            width: "280px",
                            fontFamily: "'Courier New', monospace",
                            fontSize: "11px",
                            whiteSpace: "pre",
                            lineHeight: "1.5",
                        }}
                    >
                        <div style={{ textAlign: "center", fontWeight: "bold" }}>
                            DAILY ATTENDANCE REPORT
                        </div>

                        <div>{dashLine}</div>

                        <div>Date : {attendanceDate}</div>
                        <div>Restaurant : {restaurantName || "-"}</div>

                        <div>{dashLine}</div>

                        <div style={{ fontWeight: "bold" }}>
                            {pad("ID", COL.id)}
                            {pad("Employee", COL.name)}
                            {pad("IN", COL.in)}
                            {pad("OUT", COL.out)}
                            STA
                        </div>

                        <div>{dashLine}</div>

                        {attendanceData.length === 0 ? (
                            <div>No Records Found</div>
                        ) : (
                            attendanceData.map((row, idx) => (
                                <div key={row.empId ?? idx}>
                                    {pad(row.empId, COL.id)}
                                    {pad(row.empName, COL.name)}
                                    {pad(formatPunchTime(row.firstPunchDisplay), COL.in)}
                                    {pad(formatPunchTime(row.lastPunchDisplay), COL.out)}
                                    {" "}
                                    {getStatus(row)}
                                </div>
                            ))
                        )}

                        <div>{dashLine}</div>

                        <div>Total Employees : {summary?.total || 0}</div>
                        <div>Present (PRE)  : {summary?.present || 0}</div>
                        <div>Absent  (ABS)  : {summary?.absent || 0}</div>
                        <div>Late    (LAT)  : {summary?.late || 0}</div>
                        <div>Suspense(SUS)  : {summary?.suspense || 0}</div>

                        <div>{dashLine}</div>

                        <div style={{ marginTop: "20px" }}>
                            {pad("Manager Sign", 20)}
                            HR Sign
                        </div>

                        <div style={{ marginTop: "15px" }}>
                            {pad("_______________", 20)}
                            _______________
                        </div>



                        <div>{dashLine}</div>
                    </div>
                </div>
            </div>

            <style>{`
        @media print {
          @page {
            size: 80mm auto;
            margin: 0;
          }

          body * {
            visibility: hidden;
          }

          #thermal-receipt,
          #thermal-receipt * {
            visibility: visible;
          }

          #thermal-receipt {
            position: absolute;
            left: 0;
            top: 0;
            width: 74mm !important;
            padding: 3mm;
          }
        }
      `}</style>
        </div>
    );
};

export default DailyAttendancePrint;



